import React from "react";
import LogInModal from "../components/LogInModal";
import NavBar from "../components/NavBar";
import "../css/Login.css";
import { Helmet } from "react-helmet";

export default function Login(props) {
  return (
    <>
      <Helmet>
        <title>Fiddle School</title>
        <meta
          name="description"
          content="Learn to play the fiddle with step-by-step video lessons, expert guidance from Katie Glassman, and a supportive online community."
        />

        {/* Open Graph */}
        <meta property="og:title" content="Fiddle School" />
        <meta
          property="og:site_name"
          content="Katie Glassman's Fiddle School"
        />
        <meta
          property="og:description"
          content="Learn to play the fiddle with step-by-step video lessons, expert guidance from Katie Glassman, and a supportive online community."
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:image"
          content="https://fiddleschool.com/logo192.png"
        />
        <meta property="og:url" content={window.location.href} />
      </Helmet>
      <div className="login-container">
        <NavBar />
        <LogInModal />
      </div>
    </>
  );
}
